import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ReactStars from "react-rating-stars-component";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import { getRecentlyViewedProducts } from "../../utils/recentlyViewedProducts";
import "./recentlyViewedProducts.css";

function RecentlyViewedProducts({ title = "Recently Viewed", subtitle = "Still thinking about these pairs? Pick up where you left off.", limit = 8 }) {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const syncProducts = () => {
      setProducts(getRecentlyViewedProducts().slice(0, limit));
    };

    syncProducts();
    window.addEventListener("recentlyViewedProductsUpdated", syncProducts);
    window.addEventListener("storage", syncProducts);

    return () => {
      window.removeEventListener("recentlyViewedProductsUpdated", syncProducts);
      window.removeEventListener("storage", syncProducts);
    };
  }, [limit]);

  if (!products.length) return null;

  return (
    <section className="recently-viewed-section" aria-label={title}>
      <div className="recently-viewed-heading">
        <span>Back In Your View</span>
        <h2>{title}</h2>
        <p>{subtitle}</p>
      </div>

      <div className="recently-viewed-rail">
        {products.map((product) => (
          <article className="recently-viewed-card" key={product._id}>
            <Link to={`/ProductDetail/${product._id}`} className="recently-viewed-image">
              {product.image ? (
                <img src={product.image} alt={product.name} />
              ) : (
                <span>No image</span>
              )}
            </Link>

            <div className="recently-viewed-body">
              <span className="recently-viewed-tag">{product.tag || product.brandName || "Viewed"}</span>
              <ReactStars
                edit={false}
                color="#d1d5db"
                activeColor="#facc15"
                size={18}
                value={product.ratings || 0}
                isHalf={true}
              />
              <Link to={`/ProductDetail/${product._id}`} className="recently-viewed-name">
                {product.name}
              </Link>
              <div className="recently-viewed-bottom">
                <strong>₹{product.price}</strong>
                <Link to={`/ProductDetail/${product._id}`} aria-label={`View ${product.name}`}>
                  <ShoppingBagOutlinedIcon />
                </Link>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

export default RecentlyViewedProducts;
